import { Field, Form, withFormik } from 'formik';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import * as Yup from 'yup';
import relationshipEnum from '../../../../assets/js/RelationshipEnum';
import selectedFinancierEnum from '../../../../assets/js/SelectedFinancierEnum';
import BackButton from '../../../../components/UI/BackButton/BackButton';
import Button from '../../../../components/UI/Button/CustomButton';
import Checkbox from '../../../../components/UI/Form/Checkbox/Checkbox';
import { reactGAEvent, reactGAPageview } from '../../../../helper';
import {
  getDisclosures,
  changeGreenSkyApplicationInfoValue,
  changePage,
  submitGreenSkyApplication,
  submitMindfire,
} from '../../../../redux/actions/index';
import Disclosure from '../Components/Disclosure';
import { GreenSkyFlowPageNumber } from './GreenSkyFlow';

const ApplicationConsent = props => {
  const {
    dispatchChangePage,
    dispatchSubmitGreenSkyApplication,
    applicantSubmitConsent,
    coApplicantSubmitConsent,
    dispatchChangeGreenSkyApplicationInfoValue,
    did,
    dealerUserId,
    dispatchSubmitMindfire,
    softPull,
    greenSkyApplicationInformation,
    emulatorId,
    track_id,
    consumerId,
    pqi,
    applicantAddress,
    dispatchGetDisclosures,
    app,
  } = props;

  useEffect(() => {
    dispatchGetDisclosures();
    reactGAPageview({
      path: '/ca_gssubmitconsent',
      trackerNames: [],
      title: 'ca_gssubmitconsent',
      did,
      dealerUserId,
    });
    // eslint-disable-next-line
  }, []);

  let merchantErrorMesage;

  if (app && app.error && app.error.httpErrorCode && app.error.httpErrorCode === 1) {
    merchantErrorMesage = app.error.message;
  }

  const buildInnerHtmlMerchError = () => ({
    __html: merchantErrorMesage,
  });

  const buildInnerHtml = () => ({
    __html:
      '<meta name = "format-detection" content = "telephone=no"><meta name = "viewport" content = "width=device-width, initial-scale=1"><style type="text/css">    *{ -webkit-tap-highlight-color: rgba(0, 0, 0, 0);        outline: none;        }    #gs-installment p    {         font-size: 14px;        font-family: \'Open Sans\', Arial, sans-serif;        padding-bottom: 14px;        line-height: 1.5em;        color: #000;        font-weight: 500;        text-align: justify;    }    #gs-installment sup.reg_small {        top: -5px;        font-size: 80%;    }    #gs-installment ol li {        margin-left: 35px;        padding-left: 1em;        list-style-position: outside;        text-align: justify;        font-size: 14px;        font-family: \'Open Sans\', Arial, sans-serif;    }    #gs-installment ul {        margin-left:25px;    }    #gs-installment .font-20 {        font-size: 20px;    }</style> <div id="gs-installment">    <p tabindex=\'0\'>    <strong>Please read the following <u><i>important</i></u> notices, certifications, and authorizations before submitting an application. These notices, certifications, and authorizations include Your consent for the collection/receipt of information for marketing purposes. These disclosures can be found online anytime at <a href="https://www.uat.greensky.com/disclosures/" target="_blank"><u>www.greensky.com/disclosures</u></a>. Please retain a copy of these for your records.</strong>    </p>    <ol type="I" class="account-opening-list-indent" tabindex=\'0\'>        <li tabindex="0"><strong>APPLICATION NOTICES, CERTIFICATIONS, AND AUTHORIZATIONS FOR GREENSKY<sup>&reg;</sup> CONSUMER LOAN PROGRAM            <ul class="account-opening-list-disc">                <li><strong>Important Notices from Us to You</strong></li>                <li><strong>Important Certifications and Authorizations from You to Us</strong></li>                    <ul class="account-opening-list-circle">                        <li><strong>Applicant Certifications</strong></li>                        <li><strong>Applicant Authorizations</strong></li>                    </ul>                            </ul>            </strong></li>        <li tabindex="0"><strong>MARKETING DISCLOSURES AND CONSENT FOR COLLECTION/RECEIPT OF INFORMATION FOR MARKETING PURPOSES        </strong></li>    </ol>        <br>        <p tabindex=\'0\'>            <span class="font-20">                Definitions: For the purposes of these disclosures, the following definitions apply:            </span>            <br>            <strong>&ldquo;Lender,&rdquo; &ldquo;us,&rdquo; &ldquo;we&rdquo; or &ldquo;our&rdquo;</strong> shall include any financial institution participating in the GreenSky<sup>&reg;</sup> Program. <br>            <strong>&ldquo;You&rdquo;</strong> or <strong>&ldquo;your&rdquo;</strong> shall include any applicant and any co-applicant, if any, collectively, submitting an application for a loan with the GreenSky<sup>&reg;</sup> Program.         </p>    <ol type="I" start="1" class="account-opening-list-indent">        <li tabindex="0"><strong>            APPLICATION NOTICES, CERTIFICATIONS, AND AUTHORIZATIONS FOR GREENSKY<sup>&reg;</sup> CONSUMER LOAN PROGRAM        </strong></li>    </ol>    <p>       <span class="font-20" tabindex=\'0\'>      The following notices, certifications, and authorizations are provided and made in connection with Your application for a loan from one of the financial institutions offering the GreenSky<sup>&reg;</sup> Consumer Loan Program (the &ldquo;GreenSky<sup>&reg;</sup> Program&rdquo;).        </span>     </p>    <p>      <span class="font-20" tabindex=\'0\'>      Important Notices from Us to You:      </span>      <br>        <ol>            <li tabindex=\'0\'>THE FOLLOWING IS IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT: To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens a new account. What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver&rsquo;s license or other identifying documents.</li>            <li tabindex=\'0\'>In providing your income as part of this application or any subsequent update to your income, Alimony, child support, or separate maintenance payments need not be revealed if you do not wish to have them considered.</li>            <li tabindex=\'0\'>If you request, you will be informed whether a credit report was requested and, if so, the name and address of the consumer reporting agency that furnished this report.</li>            <li tabindex=\'0\'>Where applicable, you will be charged a one-time Account Activation Fee (finance charge) of $39 at the time of first purchase.</li>            <li tabindex=\'0\'>If approved for a loan, a Shopping Pass will be issued to you. Use of your Shopping Pass or otherwise using your GreenSky<sup>&reg;</sup> Program loan to make a purchase, whether in store, online, on the telephone, with your merchant, or otherwise by any borrower authorized on the loan agreement, will constitute acceptance of the loan and the loan agreement governing the Shopping Pass by all borrowers. The physical and electronic records of any such purchase will constitute the signature of all borrowers on the loan agreement.</li>            <li tabindex=\'0\'>The following <strong>state-specific notices</strong> apply, as indicated, to California, Ohio, and Wisconsin applicants:<br>        <strong>California Residents:</strong> If you are married, you may apply for a separate account.<br>        <strong>Ohio Residents:</strong> The Ohio laws against discrimination require that all creditors make credit equally available to all credit worthy customers, and that credit reporting agencies maintain separate credit histories on each individual upon request. The Ohio civil rights commission administers compliance with this law.<br>        <strong>Married Wisconsin Residents:</strong> If you are applying for individual credit or joint credit with someone other than your spouse, and your spouse also lives in Wisconsin, combine your financial information with your spouse&rsquo;s financial information. No provision of any marital property agreement, unilateral statement under Section 766.59 of the Wisconsin statutes or court order under section 766.70 adversely affects the interest of the lender, unless the lender, prior to the time credit is granted, is furnished a copy of the agreement, statement of decree or has actual knowledge of the adverse provision when the obligation to the lender is incurred. If married, you understand that your lender must inform your spouse if a credit account is opened for you.        </li>        </ol>    </p>    <p tabindex=\'0\'>      <span class="font-20">          Important Certifications and Authorizations from You to Us:       </span>      <br><br>      <strong>          Applicant Certifications:      </strong>      <br><br>        By submitting this application for credit, <strong>you certify the following</strong>:         <ol>            <li tabindex=\'0\'>You are applying for any product that we may offer as part of the GreenSky<sup>&reg;</sup> Program regardless of any product your merchant may have specifically discussed with you.</li>            <li tabindex=\'0\'>All of the statements (whether verbally or written) communicated to us and to your merchant related to this application are true and correct and are made for the purposes of obtaining credit. </li>            <li tabindex=\'0\'>If more than one applicant is applying, each applicant intends to apply for joint credit and none is a co-signer (a &ldquo;co-signer&rdquo; is a person who agrees to be liable for the debt of another person without receiving the benefit of the loan, whereas a &ldquo;joint applicant&rdquo; is a person who intends to apply for joint credit and will receive the benefit of the loan; although we allow joint applicants to apply for joint credit, we do not allow borrowers to use &ldquo;co-signers&rdquo;).</li>        </ol>    </p>    <p tabindex=\'0\'>       <strong>           Applicant Authorizations:       </strong>       <br><br>        By submitting this loan application, <strong>you expressly authorize us to:  </strong>        <ol>            <li tabindex=\'0\'>Obtain a credit report on you for any legal purpose in connection with this loan application, including any account update, extension of credit, or review or collection of your loan.  </li>            <li tabindex=\'0\'>Share with your merchant our credit decision, including your credit score, and if approved, the credit decision and loan information, including, but not limited to, your approved credit limit, the repayment period for your loan, your approved APR, and account number. You also agree to provide additional financial information upon request.</li>            <li tabindex=\'0\'>Share with any co-applicant loan related information, including but not limited to, your credit decision, proposed loan terms, and personal credit scores, which will have the same effect as personal delivery to you. </li>            <li tabindex=\'0\'>Contact you about our products, services, special offers and other promotions at any email address provided to us now or in the future. Contact you at any mobile number and any future mobile number that you provide by phone or text message using an automated telephone dialing system or artificial or prerecorded voices, for any legal purpose, including but not limited to, servicing and collecting any loan.  You may revoke your consent at any time by contacting us at 1-866-936-0602 or P.O. Box 29429, Atlanta, GA 30359. </li>            <li tabindex=\'0\'>Share with your merchant your contact information including address, email address, and telephone number.</li>        </ol>    </p>    <ol type="I" start="2" class="account-opening-list-indent">        <li tabindex="0"><strong>            MARKETING DISCLOSURES AND CONSENT FOR COLLECTION/RECEIPT OF INFORMATION FOR MARKETING PURPOSES        </strong></li>    </ol>    <p><span tabindex="0">        In addition to providing personal information in connection with a GreenSky<sup>&reg;</sup> Program Loan application, you agree that you are providing a copy of any information, including personally-identifiable information (&ldquo;PII&rdquo;), to GreenSky Marketing, LLC (&ldquo;GS Marketing&rdquo;) for its collection, use, and disclosure consistent with the GS Marketing Privacy Policy <a href="https://www.uat.gskymarketing.com/privacy-policy" target="_blank"><u>gskymarketing.com/privacy-policy</u></a>, including, but not limited to, using and sharing such information with unaffiliated third-parties for their marketing purposes. You also authorize your GreenSky<sup>&reg;</sup> Program lender to provide GS Marketing with all information about you and your GreenSky<sup>&reg;</sup> Program loan, including, but not limited to, details about your loan and loan performance so that GS Marketing may use and/or disclose such information for GS Marketing (and/or its affiliates and third-parties) to provide you with various marketing offers. You understand and agree that your written instruction and authorizations are voluntary and shall remain in effect until you revoke them by emailing an opt-out request to marketing <a href="mailto:privacy@gskymarketing.com"><u>privacy@gskymarketing.com</u></a>.    </span></p>    <p tabindex=\'0\'>GreenSky<sup>&reg;</sup> Program NMLS #1416362</p></div>',
  });

  const handleSubmit = () => {
    reactGAEvent({
      category: 'Button',
      action: 'Click',
      label: 'Submit',
      did,
      dealerUserId,
    });
    dispatchSubmitMindfire({
      lastPage: '9024',
      dealerUserId: dealerUserId,
      did: did,
    });

    dispatchChangeGreenSkyApplicationInfoValue('applicantSubmitConsent', true);
    if (greenSkyApplicationInformation.hasCoApp) {
      dispatchChangeGreenSkyApplicationInfoValue('coApplicantSubmitConsent', true);
    }

    const softPullRequest = {
      email: softPull.softPullResponse.email || pqi.email,
      merchantId: greenSkyApplicationInformation.merchantId,
      planId: greenSkyApplicationInformation.planId,
      borrowedAmount: greenSkyApplicationInformation.borrowedAmount,
      firstName: softPull.softPullResponse.firstName || pqi.firstName,
      lastName: softPull.softPullResponse.lastName || pqi.lastName,
      middleName: softPull.softPullResponse.middleName || pqi.middleName,
      phoneNumber: softPull.softPullResponse.phoneNumber || pqi.phoneNumber,
      street: softPull.softPullResponse.street || pqi.street,
      city: softPull.softPullResponse.city || pqi.city,
      zipcode: softPull.softPullResponse.zipcode || pqi.zipcode,
      state: softPull.softPullResponse.state || pqi.state,
      applicantStreet: applicantAddress ? applicantAddress.street : null,
      applicantCity: applicantAddress ? applicantAddress.city : null,
      applicantZip: applicantAddress ? applicantAddress.zip : null,
      applicantState: applicantAddress ? applicantAddress.state : null,
      birthday: softPull.softPullResponse.birthday || pqi.birthday,
      ssnLastDigits: softPull.softPullResponse.ssnLastDigits || pqi.ssnLastDigits,
      airConditioningSystem:
        softPull.softPullResponse.airConditioningSystem || pqi.airConditioningSystem,
      isHomeowner: softPull.softPullResponse.isHomeowner || pqi.isHomeowner,
      dealerUserId: dealerUserId,
      consumerId: consumerId,
      prequalificationId: softPull.softPullResponse.prequalificationId || pqi.prequalificationId,
      ssn: greenSkyApplicationInformation.appSsn,
      selectedFinancier: selectedFinancierEnum.GREENSKY.value,
      requestedLoanAmount: greenSkyApplicationInformation.loanAmmount,
      monthlyNetIncome: (greenSkyApplicationInformation.appGrossAnnualIncome * 0.83) / 12,
      isAppMarried: greenSkyApplicationInformation.isAppMarried,
      appGrossAnnualIncome: greenSkyApplicationInformation.appGrossAnnualIncome,

      relationshipWithCoapplicant: greenSkyApplicationInformation.isCoAppSpouse
        ? relationshipEnum.SPOUSE.value
        : null,
      coapplicantFirstName: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppFirstName
        : null,
      coapplicantLastName: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppLastName
        : null,
      coapplicantMiddleName: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppMiddleInitial
        : null,
      coapplicantEmail: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppEmail
        : null,
      coapplicantPhoneNumber: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppPhoneNumber
        : null,
      coapplicantStreet: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppStreet
        : null,
      coapplicantCity: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppCity
        : null,
      coAppPoBox: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppPoBox
        : null,
      coapplicantZipcode: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppZipCode
        : null,
      coapplicantApartmentNumber: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppApartmentNumber
        : null,
      coapplicantState: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppState
        : null,
      coapplicantBirthday: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppDoB
        : null,
      coapplicantSsn: greenSkyApplicationInformation.hasCoApp
        ? greenSkyApplicationInformation.coAppSsn
        : null,
      coapplicantMonthlyNetIncome: greenSkyApplicationInformation.hasCoApp
        ? (greenSkyApplicationInformation.coAppGrossAnnualIncome * 0.83) / 12
        : null,
      isCoAppMarried: greenSkyApplicationInformation.isCoAppMarried,
      coAppGrossAnnualIncome: greenSkyApplicationInformation.coAppGrossAnnualIncome,

      applicantSpouseFirstName: greenSkyApplicationInformation.applicantSpouseFirstName,
      applicantSpouseMiddleInitial: greenSkyApplicationInformation.applicantSpouseMiddleInitial,
      applicantSpouseLastName: greenSkyApplicationInformation.applicantSpouseLastName,
      applicantSpouseApartmentNumber: greenSkyApplicationInformation.applicantSpouseApartmentNumber,
      applicantSpouseStreet: greenSkyApplicationInformation.applicantSpouseStreet,
      applicantSpouseCity: greenSkyApplicationInformation.applicantSpouseCity,
      applicantSpouseZipCode: greenSkyApplicationInformation.applicantSpouseZipCode,
      applicantSpouseState: greenSkyApplicationInformation.applicantSpouseState,

      coApplicantSpouseFirstName: greenSkyApplicationInformation.coApplicantSpouseFirstName,
      coApplicantSpouseMiddleInitial: greenSkyApplicationInformation.coApplicantSpouseMiddleInitial,
      coApplicantSpouseLastName: greenSkyApplicationInformation.coApplicantSpouseLastName,
      coApplicantSpouseApartmentNumber:
        greenSkyApplicationInformation.coApplicantSpouseApartmentNumber,
      coApplicantSpouseStreet: greenSkyApplicationInformation.coApplicantSpouseStreet,
      coApplicantSpouseCity: greenSkyApplicationInformation.coApplicantSpouseCity,
      coApplicantSpouseZipCode: greenSkyApplicationInformation.coApplicantSpouseZipCode,
      coApplicantSpouseState: greenSkyApplicationInformation.coApplicantSpouseState,

      emulatorId: emulatorId,
      track_id: track_id,
    };

    dispatchSubmitGreenSkyApplication(
      softPullRequest,
      GreenSkyFlowPageNumber.ApplicationResult,
      app,
    );
  };

  const ApplicationConsentForm = () => (
    <Form noValidate autoComplete="off">
      <Row>
        <Col xs="6">
          <Field
            component={Checkbox}
            name="applicantSubmitConsent"
            id="applicantSubmitConsent"
            label="Applicant"
            labelClassName="bold mb-0"
          />
        </Col>
        {greenSkyApplicationInformation.hasCoApp && (
          <Col xs="6">
            <Field
              component={Checkbox}
              name="coApplicantSubmitConsent"
              id="coApplicantSubmitConsent"
              label="Co-Applicant"
              labelClassName="bold mb-0"
            />
          </Col>
        )}
      </Row>
      <br />
      <p>
        By submitting this Loan Application, you agree that you are applying for any product any
        financial institution participating in the loan program (each “Lender”) may offer as part of
        the program regardless of any product(s) your merchant, provider, or retailer may have
        specifically discussed with you.
      </p>
      <Button type="submit" title={'Submit'} />
      <Disclosure />
    </Form>
  );

  const ApplicationConsentFormFormik = withFormik({
    mapPropsToValues: () => ({
      applicantSubmitConsent: applicantSubmitConsent || false,
      coApplicantSubmitConsent: coApplicantSubmitConsent || false,
    }),

    validationSchema: Yup.object({
      applicantSubmitConsent: Yup.boolean().oneOf([true], 'Please check to continue.'),
      coApplicantSubmitConsent: greenSkyApplicationInformation.hasCoApp
        ? Yup.boolean().oneOf([true], 'Please check to continue.')
        : Yup.boolean(),
    }),

    handleSubmit,
  })(ApplicationConsentForm);

  return (
    <>
      {merchantErrorMesage ? (
        <Container>
          <Row className="justify-content-center mt-5">
            <Col sm="12" xs="12" md="auto">
              <Row className="p-10 justify-content-center">
                <Col className="text-center">
                  <div
                    className="merchant-message"
                    dangerouslySetInnerHTML={buildInnerHtmlMerchError()}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container>
          <Row className="justify-content-center">
            <BackButton changePage={dispatchChangePage} page={GreenSkyFlowPageNumber.Review} />
            <Col xs="auto" sm="11">
              <Row className="greensky-disclosures">
                <Col xs="12" md="10">
                  <div title="disclosures" dangerouslySetInnerHTML={buildInnerHtml()} />
                </Col>
              </Row>
              <Row className="justify-content-center mt-5">
                <Col xs="12" md="10">
                  <ApplicationConsentFormFormik />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  greenSkyApplicationInformation: state.greenSkyApplicationInformation,
  softPull: state.softPull,
  applicantSubmitConsent: state.greenSkyApplicationInformation.applicantSubmitConsent,
  coApplicantSubmitConsent: state.greenSkyApplicationInformation.coApplicantSubmitConsent,
  dealerUserId: state.auth.dealerUserId,
  did: state.auth.did,
  emulatorId: state.auth.user.user ? state.auth.user.user.emulatorId : null,
  track_id: state.auth.track_id,
  consumerId: state.auth.consumerId,
  pqi: state.preQualificationInformation,
  applicantAddress: state.greenSkyApplicationInformation.applicantAddress,
  app: state.softPull.applicationSubmitDTO,
});

const mapDispatchToProps = dispatch => ({
  dispatchGetDisclosures: () => dispatch(getDisclosures()),
  dispatchChangePage: page => dispatch(changePage(page)),
  dispatchChangeGreenSkyApplicationInfoValue: (key, value) =>
    dispatch(changeGreenSkyApplicationInfoValue(key, value)),
  dispatchSubmitMindfire: params => dispatch(submitMindfire(params)),
  dispatchSubmitGreenSkyApplication: (params, page, app) =>
    dispatch(submitGreenSkyApplication(params, page, app)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ApplicationConsent),
);
